<template>
  <div id="user-list">
    <v-snackbar
      v-model="isSnackbarVisible"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      top
      right
      auto-height
    >
      <v-layout
        align-center
        pr-4
      >
        <v-icon
          class="pr-3"
          dark
          large
        >
          {{ snackbar.icon == 'success' ? icons.mdiCheckBold : icons.mdiCheckBold }}
        </v-icon>

        <v-layout column>
          <div>
            <strong>{{ snackbar.title }}</strong>
          </div>
          <div>{{ snackbar.text }}</div>
        </v-layout>
      </v-layout>
    </v-snackbar>

    <v-dialog
      v-model="isDialogVisible"
      max-width="600px"
    >
      <v-card>
        <v-form @submit.prevent="saveData">
          <v-card-title>
            <span class="headline">{{ modalTitle }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    v-model="row.codigo"
                    label="Cuenta"
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="row.nombre_cuenta"
                    dense
                    label="Título"
                    type="text"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="row.descripcion"
                    dense
                    label="Descripción"
                    type="text"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="row.saldo"
                    disabled
                    dense
                    label="Debe"
                    type="text"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="row.haber"
                    disabled
                    dense
                    label="Haber"
                    type="text"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="row.saldo"
                    disabled
                    dense
                    label="Saldo"
                    type="text"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error"
              outlined
              @click="isDialogVisible = false"
            >
              Cerrar
            </v-btn>
            <v-btn
              type="submit"
              color="success"
            >
              Guardar
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- list filters -->
    <h2 class="m-2">
      Cuentas contables
    </h2>
    <v-card>
      <v-btn
        color="info"
        class="m-4"
        @click="showModal(1)"
      >
        <v-icon center>
          {{ icons.mdiPlusCircle }}
        </v-icon>
        &nbsp;Agregar cuenta
      </v-btn>

      <v-data-table
        :loading="loading"
        :headers="tableColumns"
        :items="items"
      >
        <!-- SLOT PARA SALDO -->
        <template #[`item.celular`]="{ item }">
          <span class="value-box green-bg">{{ item.saldo }}</span>
        </template>

        <!-- SLOT PARA INGRESO -->
        <template #[`item.rol`]="{ item }">
          <span class="value-box green-bg">{{ item.ingreso }}</span>
        </template>

        <!-- SLOT PARA EGRESO -->
        <template #[`item.estado`]="{ item }">
          <span class="value-box red-bg">{{ item.egreso }}</span>
        </template>

        <template #[`item.acciones`]="{ item }">
          <button
            class="btn btn-green"
            @click="showModal(2, item)"
          >
            <v-icon
              center
              style="color: white"
            >
              {{ icons.mdiPencil }}
            </v-icon>
          </button>
          &nbsp;
          <button
            class="btn btn-red"
            @click="deleteData(item)"
          >
            <v-icon
              center
              style="color: white"
            >
              {{ icons.mdiDeleteOutline }}
            </v-icon>
          </button>
          &nbsp;
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import {
  mdiCheckBold, mdiDeleteOutline, mdiPencil, mdiPlusCircle,
} from '@mdi/js'
import { ref } from '@vue/composition-api'
import Vue from 'vue'
import JsonExcel from 'vue-json-excel'

Vue.component('downloadExcel', JsonExcel)

export default {
  data() {
    return {
      icons: {
        mdiDeleteOutline, mdiPencil, mdiPlusCircle, mdiCheckBold,
      },
      items: [],
      table: 'plan_de_cuentas',
      tableColumns: [
        { text: 'Cuenta', value: 'codigo', sortable: true },
        { text: 'Titulo', value: 'nombre_cuenta', sortable: true },

        // { text: 'Email', value: 'email', sortable: true },
        { text: 'Debe', value: 'debe', sortable: true },
        { text: 'haber', value: 'haber', sortable: true },
        { text: 'Saldo', value: 'saldo', sortable: true },

        // { text: 'Calificación', value: 'calificacion', sortable: true },
        // { text: 'orden Actual', value: 'orden_actual', sortable: true },
        { text: 'Acciones', value: 'acciones', sortable: false },

        // {id:0, name:}
      ],
      loading: false,
      totalItems: 0,
      isDialogVisible: false,
      row: {},
      modalTitle: 'Agregar cuenta',
      commerceList: [],
      formHasErrors: false,
      errorMessages: '',
      form: ref(null),
      valid: ref(true),
      isSnackbarVisible: false,
      message: '',
      messageColor: 'primary',
      icon: '',
      snackbar: {
        color: 'success',
        icon: 'check_circle',
        mode: 'multi-line',
        title: 'Success',
        text: 'That worked, hoorah.',
        visible: true,
      },
      statusList: [{ nombre: 'Activo' }, { nombre: 'Inactivo' }],
      rolesInAppList: [{ nombre: 'Administrador' }, { nombre: 'Conductor' }, { nombre: 'Empleado' }],
      rolesList: [
        { id: 1, nombre: 'Super Administrador' },
        { id: 2, nombre: 'Administrador' },
        { id: 3, nombre: 'Contador' },
        { id: 4, nombre: 'Atención al cliente y logística' },
        { id: 5, nombre: 'Marketing' },
      ],
      file: null,
      filename1: null,
      json_fields: {
        nombre: 'nombre',
        email: 'email',
        celular: 'celular',
      },
    }
  },
  async mounted() {
    await this.getData()

    // await this.getCommerce()
  },
  methods: {
    onFileSelected(type, item) {
      this.file1 = event.target.files[0]
      this.filename1 = Math.floor(Math.random() * 9999999999999 + 1)
      this.filename1 = `${type}_${this.filename1}.jpg`
    },
    async saveData() {
      try {
        const row = { ...this.row }

        let res
        if (row.id) {
          // es update
          delete row.id
          res = await this.$store.dispatch('put', { path: `${this.table}/modify/${this.row.id}`, data: row })
        } else {
          res = await this.$store.dispatch('post', { path: `${this.table}/new/`, data: this.row })

          // es post
        }
        this.getData()
        this.snackbar = {
          color: 'success',
          icon: 'success',
          mode: 'multi-line',
          title: 'Muy bien!',
          text: 'Registro procesado correctamente!.',
          timeout: '2500',
        }

        this.isDialogVisible = false
        this.isSnackbarVisible = true
        console.log(res)
      } catch (error) {
        console.log(error)
      }
    },
    showModal(type, item) {
      this.row = null
      if (type == 1) {
        this.modalTitle = 'Agregar cuenta'
        this.row = {}
      } else {
        this.row = item
        this.modalTitle = 'Editar cuenta'
      }
      this.isDialogVisible = true
    },
    async getData() {
      try {
        this.loading = true
        const res = await this.$store.dispatch('get', { path: `${this.table}/getAll/` })
        this.loading = false
        if (res.length > 0) {
          this.items = res
          this.totalItems = this.items.length
        }
      } catch (error) {
        this.items = []
        this.loading = false
        console.error('error', error)
      }
    },
    async getCommerce() {
      try {
        this.loading = true
        const res = await this.$store.dispatch('get', { path: 'comercios/getAll/' })
        this.loading = false
        if (res.length > 0) {
          console.log(res)
          this.commerceList = res
        }
      } catch (error) {
        this.commerceList = []
        this.loading = false
        console.error('error', error)
      }
    },
    async deleteData(item) {
      try {
        let txt
        if (confirm('¿Eliminar Registro?')) {
          this.loading = true
          const res = await this.$store.dispatch('delete', { path: `${this.table}/${item.id}` })
          await this.getData()
          this.loading = false
          txt = 'You pressed OK!'
          this.snackbar = {
            color: 'success',
            icon: 'success',
            mode: 'multi-line',
            title: 'Muy bien!',
            text: 'Registro elimiado correctamente!.',
            timeout: '2500',
          }
          this.isSnackbarVisible = true
        } else {
          // txt = 'You pressed Cancel!'
        }
      } catch (error) {
        console.log(error)
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';

.form-control {
  display: block;
  width: 100%;
  height: 34px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
}

.btn-green {
  color: rgb(255, 255, 255) !important;
  background-color: #20b11b !important;
  border-color: #20b11b !important;
}

.btn-blue {
  color: #fff !important;
  background-color: #007bff !important;
  border-color: #007bff !important;
}

.btn-red {
  color: #fff !important;
  background-color: #ff0037 !important;
  border-color: #ff0037 !important;
}

.btn {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
}

.vv-btn {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  background-color: rgb(48, 146, 48);
  color: white;
}

.value-box {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 8px;
  font-weight: bold;
  color: white;
}

.green-bg {
  background-color: #4caf50;
}

.red-bg {
  background-color: #f44336;
}
</style>
